import { render, staticRenderFns } from "./paperOrder.pug?vue&type=template&id=55daeb82&lang=pug&"
import script from "./paperOrder.ts?vue&type=script&lang=ts&"
export * from "./paperOrder.ts?vue&type=script&lang=ts&"
import style0 from "./paperOrder.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports